import { render, staticRenderFns } from "./CardTopResult.vue?vue&type=template&id=7572d38c&"
import script from "./CardTopResult.vue?vue&type=script&lang=js&"
export * from "./CardTopResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports